import { useMutation } from '@apollo/client';
import React, { useState } from 'react';
import AdminModal from '../../../components/AdminModal';
import useToast from '../../../customHooks/useToast';
import { UPDATE_PARTNER_STATUS } from '../../../graphql/admin_mutations';

import CircleCheckIcon from '../../../svgs/CircleCheckIcon';
import Styles from './ActivatePartner.module.scss';

interface IActivatePartner{
  onClose:any;
  payload:any;
  refetch:any;
}
const ActivatePartner = ({ onClose, payload, refetch }:IActivatePartner) => {
  const Toast = useToast();

  const [isSuccessful, setIsSuccessful] = useState(false);
  const [activate, { loading: activateLoading }] = useMutation<
  { updatePartnerStatus: any },
  any
>(UPDATE_PARTNER_STATUS);

  const activateAndDeactivatePartner = async () => {
    const data = { partnerId: payload?.id, isActive: true };
    if (!activateLoading) {
      try {
        const res = await activate({
          variables: data,
        });

        if (res?.data?.updatePartnerStatus && res?.data?.updatePartnerStatus?.status === 200) {
          refetch?.();
          setIsSuccessful(true);
        } else {
          Toast.error(res?.data?.updatePartnerStatus?.message || 'Operation failed');
        }
      } catch (e) {
        if (e && e.graphQLErrors && e.graphQLErrors.length > 0) {
          Toast.error(e.graphQLErrors[0].message);
        } else {
          Toast.error('Something went wrong');
        }
      }
    }
  };
  return (
    <div className={Styles.wrapper}>
      <AdminModal
        headText={isSuccessful ? 'Partner Activated!' : 'Are you sure you want to activate this partner?'}
        subText={isSuccessful ? `${payload?.name} has been activated successfully.` : 'By clicking on "Activate", you are accepting to reactivate this partner. If you are not sure, please cancel.'}
        actionBtnName="activate"
        handleModalAction={activateAndDeactivatePartner}
        topIcon={<div className={Styles.wrapper__icon}><CircleCheckIcon /></div>}
        isShow
        isActionBtnDisabled={activateLoading}
        isSuccess={isSuccessful}
        isTopIcon
        onClickAway={onClose}
        onClose={onClose}
        isLoading={activateLoading}
        hideLogo
        cancelBtnClass={Styles.wrapper__cancelBtn}
        actionBtnClass={isSuccessful ? Styles.wrapper__okayBtn : Styles.wrapper__deactivateBtn}
      />
    </div>
  );
};

export default ActivatePartner;
